import Cookie from "js-cookie";
import { AxiosRequestHeaders } from "axios";
export const apiHeaders = (): AxiosRequestHeaders => {
  // @ts-expect-error
  const headers: AxiosRequestHeaders = {
    Authorization: `Bearer ${Cookie.get("token")}`,
  };
  return headers;
};
